import { Component, OnInit, ViewChild, Inject, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LoginService } from './login.service'
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { NotificationService } from '../core/services/notification/notification.service';
import { MessageBoxComponent } from '../core/shared/message-box.component';
import { Subscription } from 'rxjs';
//import { TranslateService } from 'ng2-translate';
import { WINDOW } from './reset-password/window.provider';
import { TranslatorService } from '../core/translator/translator.service';
import { ThemesService } from '../core/themes/themes.service';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { ObjectToSelect } from '../core/shared/objectToSelect.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  readonly previousPathKey = 'PreviousVisitedPath';

  public showErrorMessage: boolean;
  public showInfoMessage: boolean;
  public hide: boolean;

  private title = 'Forma logowania';
  private isError = false;
  private message: string;
  private messageBoxSubscription: Subscription;
  customers: Array<ObjectToSelect>;

  private isMobile: boolean;
  username: string;
  password: string;
  customerSelected: ObjectToSelect = null;
  customerRequired = false;

  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;
  @ViewChild(NgForm) loginForm: NgForm;

  public constructor(
    private loginService: LoginService,
    private router: Router,
    private notificationService: NotificationService,
    private translateService: TranslatorService,
    @Inject(WINDOW) private window: Window
  ) {
    this.hide = true;
  }

  public ngOnInit() {
    this.customers = new Array<ObjectToSelect>();
  }

  userKeyDown($event){
    this.customerSelected = null;
    this.customerRequired = false;
  }


  public onSubmit(value: any) {    
      this.loginService.login(this.username, this.password, this.customerSelected)
      .subscribe(
      token => {
        let previousVisitedPath = localStorage.getItem(this.previousPathKey);
        if(previousVisitedPath != undefined) {
          this.router.navigateByUrl(previousVisitedPath);
        }
        else
        {
          const redirectUrl = '/dashboard';
          this.router.navigate([redirectUrl]);
        }
      },
      (error: string) => {
        this.isError = true;
        if(error.toString().includes('Użytkownik zewnętrzny. Należy wybrać kontrahenta.')){
          this.getCustomerForUser();
        }else{
          this.showError(error);
        }
      }
    );
  }

  public resetPassword()
  {
    let resetPassFormUrl = this.getResetPassFormUrl();
    sweetAlert('Czy zresetować hasło?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    })
      .then((value) => {
        switch (value) {
          case 'yes':
              this.loginService.sendResetFormUrl(resetPassFormUrl, this.username).subscribe(() => {
                this.showMessage('LOGIN_sendResetPasswordForm');
              });

            break;
        }
      });
  }

  private getCustomerForUser(){
    this.loginService.getCustomers(this.username).subscribe((customers: ObjectToSelect[]) => {
      this.customers = customers;
      this.customerRequired = true;
    });
  }

  private errorDismiss() {
    this.isError = false;
  }

  showMessage(message: string) {
    this.notificationService.notify(message);
    this.message = message;
    this.showInfoMessage = true;  
    setTimeout(() => this.showInfoMessage = false, 5000);   
  }

  showError(errorMessage: string) {
    this.notificationService.notify(errorMessage);
    this.message = errorMessage;
    this.showErrorMessage = true;  
    setTimeout(() => this.showErrorMessage = false, 5000);   
  }

  getResetPassFormUrl(): string {
    let url: string;
    let domain: string = this.window.location.origin;
    let resetPasswordRoute: string = 'resetpassword?token='; 
    url = `${domain}/${resetPasswordRoute}`;
    return url;
  }
}
